import { call, takeLatest, put, select, debounce } from 'redux-saga/effects'
import { find } from 'lodash'
import api from '~/helpers/api'

import { Types as UsersTypes, Creators as AccessProfileActions } from '../ducks/accessProfile'

const optionsSelector = ({ accessProfile }) => accessProfile.options

function* getAccessProfileUsers() {
  const options = yield select(optionsSelector)
  const getFilter = (property) => {
    const filterValue = find(options.filters, { name: property })
    return filterValue?.value || null
  }

  try {

    if (!getFilter('role_id')) {
      yield put(AccessProfileActions.getAccessProfileUsersFailure())
      return
    }

    const formattedParams = {
      pagination: 1,
      page: options.page + 1,
      limit: options.limit,
      order: `${options.sort},${options.direction}`,
      'role_id': getFilter('role_id'),
      'where[active]': true,
    }

    const { data } = yield call(api.get, 'users', {
      params: formattedParams,
    })
    yield put(AccessProfileActions.getAccessProfileUsersSuccess(data.data, data.total))
  } catch (e) {
    yield put(AccessProfileActions.getAccessProfileUsersFailure())
  }
}

function* reloadUsers({ ramal }) {
  yield put(AccessProfileActions.getAccessProfileUsersRequest(ramal))
}

function* getUsersFilterDealerships() {
  try {
    const { data } = yield call(api.get, 'roles', {
      params: {
        pagination: 0,
        order: 'display_name,asc',
      },
    })
    yield put(AccessProfileActions.getAccessProfileFilterRolesSuccess(data))
  } catch (e) {
    yield put(AccessProfileActions.getAccessProfileFilterRolesFailure())
  }
}

export default function* () {
  yield debounce(1000, UsersTypes.SET_ACCESS_PROFILE_SEARCH, reloadUsers)
  yield takeLatest(UsersTypes.GET_ACCESS_PROFILE_USERS_REQUEST, getAccessProfileUsers)
  yield takeLatest(UsersTypes.SET_ACCESS_PROFILE_SORT, reloadUsers)
  yield takeLatest(UsersTypes.SET_ACCESS_PROFILE_PAGE, reloadUsers)
  yield takeLatest(UsersTypes.SET_ACCESS_PROFILE_PROPERTY_FILTER, reloadUsers)
  yield takeLatest(UsersTypes.GET_ACCESS_PROFILE_FILTER_ROLES_REQUEST, getUsersFilterDealerships)
}
